import { useMutation } from '@tanstack/react-query';

import { IResendCodeRequestDto, postResendCode } from '@/shared/api/auth';

export const useResendCode = () => {
  const resendCodeMutation = useMutation({
    mutationFn: (vars: IResendCodeRequestDto) => postResendCode(vars),
  });

  const resendCode = (options: IResendCodeRequestDto) => {
    return resendCodeMutation.mutateAsync(options);
  };

  return { resendCode, isPending: resendCodeMutation.isPending };
};
